// export const API_ROOT = 'https://api-edge-jp-lab-dev.inherinext.compassbioinfo.com/'
export const API_ROOT = 'https://server-edge-jp-lab.inherinext.jp/'

// export const WS_ROOT = 'wss://api-edge-jp-lab-dev.inherinext.compassbioinfo.com/cable'
export const WS_ROOT = 'wss://server-edge-jp-lab.inherinext.jp/cable'



// WEBPACK FOOTER //
// ./src/api/config.js